import { Core } from "@faire/design-tokens";
import { Color } from "@faire/web/slate/Color";
import * as React from "react";

interface IPropTypes extends React.SVGAttributes<SVGElement> {
  color?: Color;
}

/**
 * @trackcomponent
 */
const Close: React.FunctionComponent<IPropTypes> = ({
  color = Core.icon.subdued,
  width = 15,
  height = 15,
  strokeWidth = 2,
  viewBox = "0 0 15 15",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="https://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth={strokeWidth}
    fill="none"
    strokeLinecap="square"
    {...props}
  >
    <path d="M2.667 2l11.07 11.552M2 13.07L13.552 2" />
  </svg>
);

export default Close;
